import React, { useEffect } from 'react';

interface SuccessPopupProps {
  message: string;
  onClose: () => void;
  duration?: number;
}

const SuccessPopup: React.FC<SuccessPopupProps> = ({ message, onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 px-4 pointer-events-none">
      <div className="bg-green-50 border border-green-100 rounded-lg shadow-lg px-6 py-4 max-w-md w-full animate-fade-in">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
            <i className="fas fa-check text-green-600"></i>
          </div>
          <p className="text-green-800 font-medium">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default SuccessPopup; 